import { gql, ApolloClient } from "@apollo/client";

const GENERATE_PRESIGNED_UPLOAD = gql`
  mutation GeneratePresignedUpload($input: PresignedUploadInput!) {
    result: generatePresignedUpload(input: $input) {
      uploadUrl
      objectUrl
      objectReference
      objectKey
      expiresAt
      headers {
        name
        value
      }
    }
  }
`;

const errorDetail = (error: any): string => {
  const messages = [
    error?.message,
    ...(error?.graphQLErrors || []).map((item: any) => item?.message),
    error?.networkError?.message,
    error?.networkError?.result?.errors
      ?.map((item: any) => item?.message)
      .join(", "),
  ].filter(Boolean);
  return messages.join("; ") || "No error details were returned";
};

export const uploadBlob = async (
  client: ApolloClient<any>,
  blob: Blob,
  prefix: string,
): Promise<string> => {
  let data: any;
  try {
    const result = await client.mutate({
      mutation: GENERATE_PRESIGNED_UPLOAD,
      variables: { input: { contentType: blob.type || "image/jpeg", prefix } },
    });
    data = result.data;
  } catch (error) {
    throw new Error("Could not request an upload URL: " + errorDetail(error));
  }
  const target = data?.result;
  if (!target?.uploadUrl || !target?.objectReference)
    throw new Error("The API did not return an upload URL");

  const headers = (target.headers || []).reduce(
    (
      result: Record<string, string>,
      header: { name: string; value: string },
    ) => ({ ...result, [header.name]: header.value }),
    {},
  );
  let response: Response;
  try {
    response = await fetch(target.uploadUrl, {
      method: "PUT",
      headers,
      body: blob,
    });
  } catch (error) {
    throw new Error("Storage request failed: " + errorDetail(error));
  }
  if (!response.ok) {
    const responseBody = await response.text();
    throw new Error(
      "Storage rejected the upload (" +
        response.status +
        "): " +
        (responseBody || response.statusText),
    );
  }
  return target.objectReference;
};
